import { create } from "zustand";
import { persist } from "zustand/middleware";

export type SelectedDeviceStore = {
  selectedDevice: string | null;
  setSelectedDevice: (selectedDevice: string) => void;
  resetSelectedDevice(): void;
};

export const useSelectedDeviceStore = create<SelectedDeviceStore>()(
  persist(
    (set): SelectedDeviceStore => ({
      selectedDevice: null,
      setSelectedDevice: (selectedDevice: string) => set({ selectedDevice }),
      resetSelectedDevice: () => set({ selectedDevice: null }),
    }),
    {
      name: "selectedDevice",
    },
  ),
);
